import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import Cookies from 'universal-cookie';


const PrivateRoute = props => {
    const cookies = new Cookies();

    const isLogged = !! cookies.get('ckCPF')

    return isLogged ? <Route {...props}/> : <Redirect to="/" />
}

export default PrivateRoute
